import gql from 'graphql-tag'
import { graphql, ChildDataProps } from 'react-apollo'

export type InputProps = {}

export type Variables = {
  hourlyRate: number
  version: string
}

export type Response = {}

type ChildProps = ChildDataProps<InputProps, Response, Variables>

const CHANGE_POSITION_HOURLY_RATE_MUTATION = gql`
  mutation changeCalcHourlyRate($hourlyRate: Float!, $version: String!) {
    changeCalcHourlyRate(hourlyRate: $hourlyRate, version: $version)
  }
`

const withChangePositionHourlyRateMutation = graphql<InputProps, Response, Variables, ChildProps>(
  CHANGE_POSITION_HOURLY_RATE_MUTATION,
  {
    name: 'changePositionHourlyRate',
  },
)

export default withChangePositionHourlyRateMutation
